import { useEffect, useState } from 'react';
import { SiTrackPage } from '../../components/si-track-page';
import { Tab, Tabs } from '@mui/material';
import { TabPanel } from '../../components/tab-panel';
import CustomQueryPage from './custom-query/custom-query.page';
import SavedQueryPage from './saved-query/saved-query.page';
import { useSearchParams } from 'react-router-dom';

const QueryBuilderPage = () => {
  const [searchParams] = useSearchParams();
  const [currentTab, setCurrentTab] = useState<'custom_query' | 'saved_query'>('custom_query');

  useEffect(() => {
    const tabParam = searchParams.get('tab') as 'custom_query' | 'saved_query';
    setCurrentTab(tabParam || 'custom_query'); // Default to 'custom_query' if no tab parameter exists
  }, [searchParams]);

  const handleTabsChange = (event: any, value: any) => {
    setCurrentTab(value);
  };
  return (
    <SiTrackPage title="Custom Report">
      <div className="innerContent">
        {' '}
        <Tabs value={currentTab} onChange={handleTabsChange}>
          <Tab value="custom_query" label="Custom Query" />
          <Tab value="saved_query" label="Saved Query" />
        </Tabs>
        <TabPanel selectedValue={currentTab} value="custom_query">
          <CustomQueryPage />
        </TabPanel>
        <TabPanel selectedValue={currentTab} value="saved_query">
          <SavedQueryPage />
        </TabPanel>
      </div>
    </SiTrackPage>
  );
};

export default QueryBuilderPage;
